<template>
    <div class="publicTitle">
        <div class="publicTxt">{{text}}</div>
        <div class="publicLine"></div>
    </div>
</template>

<script>
    export default {
        props:{
            text:{
                type:String,
                default(){
                    return ""
                }
            }
        }
    }
</script>
<style scoped>
 /* 公共标题 */
.publicTitle{
    padding: 15px;
    text-align: center;
    font-weight: bold;
    font-size:18px;
    color: var(--color-main);
}
.publicTitle .publicLine{
    width:30px;
    height:5px;
    background:var(--color-main);
    margin:10px auto 0;
}
@media screen and (max-width: 768px){
    .publicTitle{
        height:1.2rem;
        padding:0;
        font-size:0.32rem;
    }
    .publicTitle .publicTxt{
        padding-top:0.3rem;
    }
    .publicTitle .publicLine{
        width:0.6rem;
        height:0.07rem;
        margin:0.15rem auto 0;
    }
}
</style>